module.exports = __webpack_public_path__ + "static/hope-and-main-white-3334465ade2a802b1a8f480b6e925e8e.svg";